<template>
  <span class="Badge" :class="[variationName('tone', tone)]">
    <p-icon v-if="progress" :accessibilityLabel="accessibilityLabel">
      <svg class="Svg" viewBox="0 0 20 20">
        <path
          v-if="progress === 'complete'"
          d="M6 10c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.121-2.122C8.605 6 9.07 6 10 6c.93 0 1.395 0 1.776.102a3 3 0 0 1 2.122 2.122C14 8.605 14 9.07 14 10s0 1.395-.102 1.777a3 3 0 0 1-2.122 2.12C11.395 14 10.93 14 10 14s-1.395 0-1.777-.102a3 3 0 0 1-2.12-2.121C6 11.395 6 10.93 6 10Z"
        />
        <path
          v-else-if="progress === 'partiallyComplete'"
          fill-rule="evenodd"
          d="m8.888 6.014-.017-.018-.02.02c-.253.013-.45.038-.628.086a3 3 0 0 0-2.12 2.122C6 8.605 6 9.07 6 10s0 1.395.102 1.777a3 3 0 0 0 2.121 2.12C8.605 14 9.07 14 10 14c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.121C14 11.395 14 10.93 14 10c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.122-2.122C11.395 6 10.93 6 10 6c-.475 0-.829 0-1.112.014ZM8.446 7.34a1.75 1.75 0 0 0-1.041.94l4.314 4.315c.443-.2.786-.576.941-1.042L8.446 7.34Zm4.304 2.536L10.124 7.25c.908.001 1.154.013 1.329.06a1.75 1.75 0 0 1 1.237 1.237c.047.175.059.42.06 1.329ZM8.547 12.69c.182.05.442.06 1.453.06h.106L7.25 9.894V10c0 1.01.01 1.27.06 1.453a1.75 1.75 0 0 0 1.237 1.237Z"
        />
        <path
          v-else-if="progress === 'incomplete'"
          fill-rule="evenodd"
          d="M8.547 12.69c.183.05.443.06 1.453.06s1.27-.01 1.453-.06a1.75 1.75 0 0 0 1.237-1.237c.05-.182.06-.443.06-1.453s-.01-1.27-.06-1.453a1.75 1.75 0 0 0-1.237-1.237c-.182-.05-.443-.06-1.453-.06s-1.27.01-1.453.06A1.75 1.75 0 0 0 7.31 8.547c-.05.183-.06.443-.06 1.453s.01 1.27.06 1.453a1.75 1.75 0 0 0 1.237 1.237ZM6.102 8.224C6 8.605 6 9.07 6 10s0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C8.605 14 9.07 14 10 14s1.395 0 1.777-.102a3 3 0 0 0 2.12-2.121C14 11.395 14 10.93 14 10c0-.93 0-1.395-.102-1.776a3 3 0 0 0-2.121-2.122C11.395 6 10.93 6 10 6c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122Z"
        />
      </svg>
    </p-icon>
    <p-text as="span" variant="bodySm" :fontWeight="tone === 'new' ? 'medium' : undefined">
      <slot></slot>
    </p-text>
  </span>
</template>

<script>
import { variationName } from '@/components/polaris/polarisUtils';
import PText from '@/components/polaris/PText';
import PIcon from '@/components/polaris/PIcon';

export default {
  name: 'PBadge',
  components: { PText, PIcon },
  props: {
    tone: { type: String, default: '' },
    progress: String,
    accessibilityLabel: String,
  },
  methods: {
    variationName,
  },
};
</script>

<style scoped lang="scss">
.Badge {
  // stylelint-disable -- Polaris component custom properties
  --pc-badge-horizontal-padding: var(--p-space-200);
  --pc-badge-vertical-padding: var(--p-space-050);
  // stylelint-enable
  display: inline-flex;
  align-items: center;
  // stylelint-disable-next-line -- generated by polaris-migrator DO NOT COPY
  padding: var(--pc-badge-vertical-padding) var(--pc-badge-horizontal-padding);
  background-color: var(--p-color-bg-fill-transparent-secondary);
  border-radius: var(--p-border-radius-200);
  color: var(--p-color-text-secondary);
  font-weight: var(--p-font-weight-medium);

  svg {
    fill: var(--p-color-text-secondary);
  }

  @media print {
    border: solid var(--p-border-width-025) var(--p-color-border);
  }
}

.toneSuccess {
  background-color: var(--p-color-bg-fill-success-secondary);
  color: var(--p-color-text-success);

  svg {
    fill: var(--p-color-icon-success);
  }
}

.toneSuccess-strong {
  color: var(--p-color-text-success-on-bg-fill);
  background-color: var(--p-color-bg-fill-success);

  svg {
    fill: var(--p-color-text-success-on-bg-fill);
  }
}

.toneInfo {
  background-color: var(--p-color-bg-fill-info-secondary);
  color: var(--p-color-text-info);

  svg {
    fill: var(--p-color-icon-info);
  }
}

.toneOpw {
  background-color: var(--v-upgrade_button-base);
  color: var(--p-color-text-success-on-bg-fill);

  svg {
    fill: var(--p-color-text-success-on-bg-fill);
  }
}

.toneInfo-strong {
  color: var(--p-color-text-info-on-bg-fill);
  background-color: var(--p-color-bg-fill-info);

  svg {
    fill: var(--p-color-text-info-on-bg-fill);
  }
}

.toneAttention {
  background-color: var(--p-color-bg-fill-caution-secondary);
  color: var(--p-color-text-caution);

  svg {
    fill: var(--p-color-icon-caution);
  }
}

.toneAttention-strong {
  color: var(--p-color-text-caution-on-bg-fill);
  background-color: var(--p-color-bg-fill-caution);

  svg {
    fill: var(--p-color-text-caution-on-bg-fill);
  }
}

.toneWarning {
  background-color: var(--p-color-bg-fill-warning-secondary);
  color: var(--p-color-text-warning);

  svg {
    fill: var(--p-color-icon-warning);
  }
}

.toneWarning-strong {
  color: var(--p-color-text-warning-on-bg-fill);
  background-color: var(--p-color-bg-fill-warning);

  svg {
    fill: var(--p-color-text-warning-on-bg-fill);
  }
}

.toneCritical {
  background-color: var(--p-color-bg-fill-critical-secondary);
  color: var(--p-color-text-critical);

  svg {
    fill: var(--p-color-icon-critical);
  }
}

.toneCritical-strong {
  color: var(--p-color-text-critical-on-bg-fill);
  background-color: var(--p-color-bg-fill-critical);

  svg {
    fill: var(--p-color-text-critical-on-bg-fill);
  }
}

.toneNew {
  border: none;
  background-color: var(--p-color-bg-fill-transparent-secondary);
  color: var(--p-color-text-secondary);
  font-weight: var(--p-font-weight-bold);
  border-radius: var(--p-border-radius-200);

  svg {
    fill: var(--p-color-text-secondary);
  }
}

.toneMagic {
  background-color: var(--p-color-bg-fill-magic-secondary);
  color: var(--p-color-text-magic);

  svg {
    fill: var(--p-color-text-magic);
  }
}

.toneRead-only {
  color: var(--p-color-text-secondary);
  background-color: transparent;

  svg {
    fill: var(--p-color-icon-secondary);
  }
}

.toneEnabled {
  color: var(--p-color-text);

  svg {
    fill: var(--p-color-icon-success);
  }
}

.sizeLarge {
  padding: var(--p-space-100) var(--p-space-200);
}

.withinFilter {
  border-radius: var(--p-border-radius-100);
}

.Icon {
  margin: calc(-1 * var(--p-space-050)) 0 calc(-1 * var(--p-space-050))
    calc(-1 * var(--p-space-200));

  svg {
    // Corrects conflicting alignment with ancestor elements
    display: inline-block;
    vertical-align: top;
  }

  .sizeLarge & {
    margin: 0 var(--p-space-100) 0 calc(-1 * var(--p-space-050));
  }

  + * {
    margin-left: 0;
  }
}

.PipContainer {
  display: grid;
  align-items: center;
  margin-left: calc(-1 * var(--p-space-050));
  margin-right: var(--p-space-100);
}
</style>
